module.exports = {
  "recommended_assets": "Recommended Assets",
  "headers": {
    "actions": {
      "seek": "seek",
      "share": "Share",
      "download": "Download",
      "generate_link": "Generate link",
      "analytics": "Analytics",
      "more": {
        "edit": "Edit",
        "add_to_collection": "Add to collection",
        "clone_asset": "Clone asset",
        "google_slides": "Google Slides",
        "google_sheets": "Google Sheets",
        "google_docs": "Google Docs",
        "edit_image": "Edit image",
        "add_pages": "Add pages",
      }
    }
  }, 
  "edit": {
    "source": "Source",
    "publisher": "Publisher",
    "last_updated": "Last updated",
    "created_on":"Created On",
    "expiration": "Expiration",
    "pick_a_date": "Pick a date",
    "edit_new_picture": "Edit new <br/> picture",
    "actions": {
      "upload_new_version": "Upload new version"
    },
    "name": "Name",
    "description": {
      "title": "Description",
      "actions": {
        "internal": "Internal",
        "external": "External"
      }
    },
    "edit_captions": "Edit video caption",
    "tags": "Tags",
    "recommended_tags": {
      "title": "Recommended Tags",
      "description": "Tags help to locate your file easily. Fancy any of these?"
    },
    "asset_access": {
      "title": "Asset Access",
      "options": {
        "share": "Share",
        "download": "Download"
      }
    },
    "viewer": "Viewer",
    "viewer_options": {
      "render_in_viewer": "Render in viewer",
      "render_optimized_view": "Render optimized view",
      "open_in_new_tab": "Open in new tab"
    },
    "select_viewer": "Select viewer",
    "error_messages": {
      "name": "Please provide a valid name",
      "url": "Please provide a valid url"
    },
    "warning": {
      "heading": " Are you like 'sure' sure?",
      "sub_text": " This asset has",
      "description": "If you mark this asset as internal, you can share this only with Paperflite users within your team. Anyone else you've shared this with will lose access. Are you sure you want to continue?",
      "actions": {
        "sure": "Sure, lezz go!",
        "nope": "Nope"
      }
    }
  },
  "analytics": {
    "publisher": "Publisher",
    "created_on":"Created On",
    "last_updated": "Last Updated",
    "view_by": "View by",
    "expired_on": "Expired on",
    "expires_on": "Expires on",
    "smart_insights": "Smart Insights",
    "actions": {
      "all": "All",
      "teams": "Teams",
      "audience": "Audience"
    },
    "headers": {
      "views": "Views",
      "downloads": "Downloads",
      "shares": "Shares",
      "avg_time": "Avg Time"
    },
    "error_messages": {
      "asset_insights" :"Sorry, we do not have enough information to provide insights on this asset."
    }
  },
  "cloning": {
    "title": "cloning",
    "description": "Select a Stream or a Collection below to clone what you've selected",
    "actions": {
      "my_streams": "My Streams",
      "my_collections": "My Collections"
    },
    "clone_your_file_to": "Clone your file to",
    "success": "Your asset is successfully cloned!",
    "go_to": "Go to",
    "stay_here": "Stay here",
    "cloned_asset": "Cloned Asset"
  },
  "viewers": {
    "default_viewer": "Click here to download this file",
    "generating_preview": "Generating preview",
    "click_here_to_preview": "Click here to preview",
    "open_in_new_tab": "Open in new tab",
    "empty_messages": {
      "empty_sheet": {
        "title": "Empty sheet",
        "message": "Even the best sheets start blank. <br/> Add your data and come back to watch it come to life!"
      }
    }
  },
  "edit_captions": {
    "title": "Editing",
    "sub_text": "your video caption",
    "timestamp": "Timestamp",
    "captions": "Captions",
    "upload_file": "Upload new VTT",
    "note": "NOTE : Edit captions at specific timestamps or upload a new VTT file for personalized and accurate captioning."
  },
  "asset_detail_view": {
    "processing": "Processing asset",
    "refresh": "This might take sometime, the page will refresh automatically",
    "office": {
      "error_messages": {
        "title": "Mmm... who moved my cheese?",
        "rules": "Who sets these rules, anyway?",
        "unsupported_file": "Sorry!  Someone passed you the wrong information. You were never supposed to see me :). Looks like this is not a Microsoft-supported file type.",
        "asset_not_exist": "Sorry!  Some one passed you the wrong information. You were never supposed to see me :). This asset does not exist any longer.",
        "not_authorized": "I'm sorry! It seems like I'm not authorised to show what you are looking for. I hate disappointing you :("
      }
    },
    "gdocs": {
      "preparing": "Preparing editor for asset"
    },
    "page_viewer": {
      "toast": {
        "title": "In Progress",
        "sub_text": "Crafting.Stand by"
      }
    },
    "image_viewer":{
      "error_message":{
        "title": "File not found",
        "sub_text": "Looks like this file has been deleted or moved to a different location. Please contact your administrator or the sender for more details."
      }
    }
  }
}